import { OrderColumnProps } from './OrderColumnProps';
import { ShipmentColumnProps } from './ShipmentColumnProps';

export type ColumnProps = OrderColumnProps | ShipmentColumnProps;

export const isOrderColumnProps = (
  props: ColumnProps,
): props is OrderColumnProps => {
  return props.type === 'ORDER';
};

export const isShipmentColumnProps = (
  props: ColumnProps,
): props is ShipmentColumnProps => {
  return props.type === 'SHIPMENT';
};
